<template>
  <div class="b-footer">
    <div class="b-container">
      <div class="b-main">
        <div class="b-footer-contactList">
          <ul>
            <li v-for="item in fcontactList"
                :key="item">
              <div class="b-cion">
                <img :src="item.coin"
                     alt="img" />
              </div>
              <div class="b-name">{{ item.name }}：</div>
              <div class="b-description">{{ item.description }}</div>
            </li>
          </ul>
        </div>
        <div class="b-wxcode">
          <img :src="wxcode"
               alt="wxcode">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data () {
    return {
      fcontactList: [],
      wxcode: ''
    };
  },
  mounted () {
    this.fcontactList = [
      {
        coin: require("../../assets/img/icion.png"),
        name: "闵行基地",
        description: "上海市闵行区东川路800号"
      },
      {
        coin: require("../../assets/img/mail.png"),
        name: "邮箱",
        description: "xxx@transmed.sjtu.edu.cn"
      },
      // {
      //   coin: require("../../assets/img/wx.png"),
      //   name: "微信公众号",
      //   description: "123456"
      // }
    ];
    this.wxcode = require("../../assets/img/wxcode.png")
  }
};
</script>
<style lang="scss" scoped>
.b-footer {
  background: rgb(247, 247, 247);
  padding:30px 0;
  .b-footer-contactList {
    border-top: 3px solid #2ba8e2;
    padding-top:10px;
    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      li {
        display: flex;
        align-items: center;
        .b-cion {
          width: 20px;
          height: 20px;
        }
        .b-name,
        .b-description {
          text-align: inherit;
          font-weight: normal;
          font-family: Avenir, Helvetica, Arial, sans-serif;
          line-height: inherit;
          display: inline-block;
          font-size: 16px;
          color: rgb(0, 0, 0);
          padding-left: 5px;
        }
      }
    }
  }
  .b-wxcode {
    width: 130px;
    height: 130px;
    margin: 20px auto 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue